<template>
  <div class='header-session-settings'>
    <v-flex>
      <v-dialog v-if="pageType=='session'" v-model='sessionSettingsDialog' fullscreen hide-overlay transition='dialog-bottom-transition'>
        <template v-slot:activator='{on}'><v-btn v-on='on' color='#0000ff' dark>SESSION SETTINGS</v-btn></template>
        <v-card class='session-settings-card'>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="sessionSettingsDialog = false">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
            <v-toolbar-title>Settings</v-toolbar-title>
          </v-toolbar>
          <!--Password Reset-->
          <v-subheader>Session Settings</v-subheader>
          <v-layout wrap>
            <v-flex xs12 ml-5 pl-1><h3>Password Reset</h3></v-flex>
            <v-flex xs12 ml-5 pl-1>If you are the creator of this session you can reset the password below. WARNING: THIS IS NOT REVERSIBLE!</v-flex>
            <v-flex xs3 ml-5 pl-3><v-text-field v-model='newPassword' label='New password' type='password' required></v-text-field></v-flex>
            <v-flex xs3 ml-3 pl-3><v-text-field v-model='confirmPassword' label='Repeat new password to confirm' type='password' required></v-text-field></v-flex>
            <v-flex><v-btn color='blue darken-1' text @click.native='resetPassword()'>Confirm</v-btn></v-flex>
          </v-layout>
          <v-divider></v-divider>

          <!--Timer Settings-->
          <v-subheader>Timer Settings</v-subheader>
          <v-layout wrap>
            <v-flex xs12 ml-5 pl-1><h3>Average</h3></v-flex>
            <v-flex xs12 ml-5 pl-1>Update the averages view for this the times table (comma separated list of AoN (average), MoN (mean), time (current time), streak (win streak), or score (total wins) where N is the number of solves to consider)</v-flex>
            <v-flex xs5 ml-5 pl-3><v-text-field v-model='averages' label='eg. Ao5, Ao12'></v-text-field></v-flex>
            <v-flex><v-btn color='blue darken-1' text @click.native='saveSettings()'>Submit</v-btn></v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12 ml-5 pl-1><h3>Stackmat</h3></v-flex>
            <v-flex xs12 ml-5 pl-1>Enable/Disable stackmat capabilities (you will need to give this website microphone permissions)</v-flex>
            <v-flex xs5 ml-5 pl-3><v-btn depressed color='primary' @click='toggleStackmat'>{{ stackmatEnabled ? 'Disable' : 'Enable' }} Stackmat</v-btn></v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12 ml-5 pl-1><h3>Inspection</h3></v-flex>
            <v-flex xs12 ml-5 pl-1>Enable/Disable inspection countdown</v-flex>
            <v-flex xs5 ml-5 pl-3><v-btn depressed color='primary' @click='inspectionEnabled = !inspectionEnabled; saveSettings()'>{{ inspectionEnabled ? 'Disable' : 'Enable' }} Inspection</v-btn></v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12 ml-5 pl-1><h3>Timer</h3></v-flex>
            <v-flex xs12 ml-5 pl-1>Input times by typing (XX:XX:XX.XX)</v-flex>
            <v-flex xs5 ml-5 pl-3><v-btn depressed color='primary' @click='typingTimer = !typingTimer; saveSettings()'>{{ typingTimer ? 'Disable' : 'Enable' }} Typing</v-btn></v-flex>
          </v-layout>
          <v-divider></v-divider>
        </v-card>
      </v-dialog>
    </v-flex>
  </div>
</template>

<script>
import SessionsService from '@/services/SessionsService'
import Stackmat from 'stackmat'

export default {
  name: 'header-session-settings',
  data () {
    return {
      sessionSettingsDialog: false,
      newPassword: '', // TODO: creator can update password without entering session (ie, using email + password)
      confirmPassword: '',

      averages: 'Ao5, Ao12, time',
      stackmatEnabled: false,
      inspectionEnabled: true,
      typingTimer: false
    }
  },
  props: {
    loggedIn: Boolean,
    pageType: String // eg. dashboard, session, etc.
  },
  methods: {
    async resetPassword () {
      if (this.newPassword === '') {
        alert('New Password cannot be empty')
        return
      }
      if (this.newPassword !== this.confirmPassword) {
        alert('The second password field does not match the first. Try inputing the passwords again to confirm')
        return
      }
      var response = await SessionsService.resetPassword(this.$store.state.sessionId, {
        solverId: this.$store.state.solverId,
        authToken: this.$store.state.authToken,
        globalAuthToken: this.$store.state.globalAuthToken,
        newPassword: this.newPassword
      })
      if (response.data.success === true) {
        alert('Successfully updated password')
      } else {
        alert('Failed to update password due to error: ' + response.data.error)
      }
      this.sessionSettingsDialog = false
    },
    toggleStackmat () {
      this.stackmatEnabled = !this.stackmatEnabled
      if (this.stackmatEnabled) {
        let x = new Stackmat()
        x.start()
        alert('NOTE: You may need to refresh the page occasionally for stackmat functionality to work. At the moment this works best on Chrome however most modern browsers are supported.')
      }
      this.saveSettings()
    },
    saveSettings () {
      let sessionTimesSettings = {
        averages: this.averages,
        stackmatEnabled: this.stackmatEnabled,
        inspectionEnabled: this.inspectionEnabled,
        typingTimer: this.typingTimer
      }
      this.$store.commit('setSessionTimesSettings', sessionTimesSettings)
      localStorage.setItem('sessionTimesSettings', JSON.stringify(sessionTimesSettings))
      alert('Saved settings. Refresh this page to apply the new setting.')
    },
    updatedDialog (val) {
      if (val) {
        this.$emit('open-dialog')
      } else {
        this.$emit('close-dialog')
      }
    }
  },
  mounted () {
    let sessionTimesSettings = this.$store.state.sessionTimesSettings
    if (sessionTimesSettings.averages !== undefined) this.averages = sessionTimesSettings.averages
    if (sessionTimesSettings.stackmatEnabled !== undefined) this.stackmatEnabled = sessionTimesSettings.stackmatEnabled
    if (sessionTimesSettings.inspectionEnabled !== undefined) this.inspectionEnabled = sessionTimesSettings.inspectionEnabled
    if (sessionTimesSettings.typingTimer !== undefined) this.typingTimer = sessionTimesSettings.typingTimer
  },
  watch: {
    sessionSettingsDialog (val) {
      this.updatedDialog(val)
    }
  }
}
</script>

<style scoped>
.session-settings-card {
  text-align: start;
}
</style>
